import namespace from './namespace';

export default {    
    [namespace.state.MAPPINGS_GROUPS]: [],
    [namespace.state.AVAILABLE_JIRA_VALUES]: [],
    [namespace.state.AVAILABLE_TFS_VALUES]: [],
    [namespace.state.LOADER_VISIBLE]: false,
    [namespace.state.SELECTED_JIRA_FIELD]: null,
    [namespace.state.SELECTED_TFS_FIELD]: null
};


// WEBPACK FOOTER //
// ./src/store/modules/fieldsMapping/state.js